import { Component, Input, ViewEncapsulation } from '@angular/core';
import { InfoGroup } from '../../domain/info-group';
import { JuiIcon } from '@jump-tech-frontend/core-components-angular';


@Component({
    selector: 'crds-information-groups',
    template: `
    @for (infoGroup of infoGroups; track infoGroup; let i = $index) {
      <div class="information-group">
        <div class="information-group__sign">
          <div class="information-group__icon">
            <jui-icon [name]="infoGroup.groupImage.name" size="xl"></jui-icon>
          </div>
        </div>
        <div class="information-group__text" [innerHTML]="infoGroup.groupDescription"></div>
      </div>
    }
    `,
    styleUrls: ['../../sass/relay.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [JuiIcon]
})
export class InformationGroupsComponent {
  @Input() infoGroups: InfoGroup[];

  isOdd(i: number) {
    return i % 2 === 1;
  }
}
